import { UNLIMITED_SUM_INSURED } from "@/config/coverages";

/** Display form of a sum insured: the maximum (100'000) counts as unlimited everywhere in the funnel. */
export const formatSumInsured = (value: number, t: (key: string) => string): string =>
  value >= UNLIMITED_SUM_INSURED ? t("coverages.sumInsuredUnlimited") : `CHF ${value.toLocaleString("de-CH")}`;
